import * as Yup from 'yup';
import { manifestFormValidationSchema } from './create-manifest.schemas';
import { TransportType } from 'utils/transportTypes';

type ManifestsSchema = Yup.InferType<typeof manifestFormValidationSchema>;

export enum ManifestFormSteps {
    MANIFEST = 'manifest',
    TRANSPORT_DETAILS = 'transportDetails',
    TEAM = 'team',
}

export enum ContainerStatuses {
    UNACOOMPANIED = 0,
    ACCOMPANIED = 1,
}

// Defaults for all manifests
export const UK_COUNTRY_CODE = 'GB';
const IRELAND_DUBLIN_PORT_CODE = 'IEDUB100';

export type ManifestFormFields = Omit<ManifestsSchema, ManifestFormSteps.TRANSPORT_DETAILS> & {
    [ManifestFormSteps.TRANSPORT_DETAILS]: Omit<
        ManifestsSchema[ManifestFormSteps.TRANSPORT_DETAILS],
        'containerIndication' | 'transportTypeId'
    > & {
        containerIndication?: ContainerStatuses;
        transportTypeId?: TransportType;
        departurePort?: string;
    };
};

export const initialManifestValues: ManifestFormFields = {
    [ManifestFormSteps.MANIFEST]: {
        referenceId: '',
    },

    [ManifestFormSteps.TRANSPORT_DETAILS]: {
        containerIndication: ContainerStatuses.UNACOOMPANIED,
        transportTypeId: undefined,
        meansIdentificationType: '',
        nationalityTransportMeans: '',
        vehicleRegistration: '',
        carrierOrHaulier: '',
        countryOfDispatch: UK_COUNTRY_CODE,
        departurePort: '',
        customsOfficeOfPresentation: IRELAND_DUBLIN_PORT_CODE,
        departureDateTime: '',
        arrivalDateTime: '',
        meansId: '',
    },
    [ManifestFormSteps.TEAM]: {
        teamId: '',
    },
};
